import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Image, Row } from "react-bootstrap";
import { AppLayout } from "../../layouts";
import { Header, Sides } from "../../components";

const ProfileCommonPage = ({ loginData, rightSide1, profileImageLink }) => {
  const { t } = useTranslation();

  const rightSide = (
    <Container fluid className="exado-container1">
      <Row className="exado-row1">
        <Col>
          <Header.HeadingPage pageHeading={t("profile_page.title")} />
        </Col>
      </Row>
      <Row className="exado-row1" >
        <Col xs='auto'>
          <div className="profile-img-blk">
            <Image src={profileImageLink} className="profile-img" />
          </div>
        </Col>
        <Col xs='auto' className="exado-col" >
          <h3>{t("Hello")}, {loginData?.fullName}</h3>
        </Col>
      </Row>
      {rightSide1}
    </Container>
  );
  return (
    <AppLayout.AppLayoutOne
      leftSide={<Sides.LeftSides loginData={loginData} />}
      rightSide={rightSide}
    />
  );
};

export default ProfileCommonPage;
